import { useCookies } from 'react-cookie'
import { useWebview } from 'context'
import useIsWebview from '@app.modules/hooks/useIsWebview'
import {
  AOS_APP_VERSIONS,
  IOS_APP_VERSIONS,
  VERIFIED_APP_VERSIONS,
} from 'constants/verifyAppVersion/verifyAppVersionList'

export type TVersionKey = keyof typeof VERIFIED_APP_VERSIONS

/**
 * 앱 버전에 따라 특정 기능의 노출 여부를 판단하는 범용 훅입니다.
 *
 * 특정 버전 이상일 경우에만 관련 영역이 노출될 수 있도록 Boolean값을 반환하며,
 * 웹뷰가 아닐 경우 무조건 true를 반환합니다.
 *
 * @param versionKey - 확인할 버전 키
 * - 'CAREER_NAVER_LICENSE': 네이버 자격증 연동
 * - 'COVER_LETTER_AD_EDUCATION': 자만검 배너 및 공고 상세 추천 교육
 * - 'SCRAP_USER_STATISTICS': 공고 상세 관심 유저 통계
 * - 'TEAM_RECRUIT': 팀원 모집
 * - 'COMPANY_INFO': 기업정보 더보기
 * @returns {boolean} 기능 노출 여부
 */

const useShowComponentByAppVersion = (versionKey: TVersionKey): boolean => {
  const isWebview = useIsWebview()
  const [cookies] = useCookies()
  const { verifyAppVersionRequirement } = useWebview({
    appVersion: cookies?.appVersion,
  })

  const isComponentVisible = isWebview
    ? verifyAppVersionRequirement({
        ios: IOS_APP_VERSIONS[versionKey],
        aos: AOS_APP_VERSIONS[versionKey],
      })
    : true

  return isComponentVisible
}

export default useShowComponentByAppVersion
